import React from 'react';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import { Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import Header from 'app/components/layout/Header';
import SectionGroup from 'app/components/general/SectionGroup';
import ConnectionGroup from 'app/components/general/ConnectionGroup';
import StatusBadge from 'app/components/general/StatusBadge';
import CopyCaption from 'app/components/general/CopyCaption';

import { simpleDateTwo, formatAmount } from 'app/utils/parsers';
import { IPayout } from 'app/ducks/payouts/types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PaymentCollectionsTableTeamMembers from 'app/components/teamPaymentRequests/PaymentCollectionsTableTeamMembers';

import * as payoutsActions from 'app/ducks/payouts/actions';
import * as paymentCollectionActions from 'app/ducks/teamPaymentCollections/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as payoutsSelectors from 'app/ducks/payouts/selectors';
import * as teamPaymentCollectionsSelectors from 'app/ducks/teamPaymentCollections/selectors';

import CompetitionIcon from 'app/images/icons/organisation.svg';

function selector(state) {
  return {
    payouts: payoutsSelectors.getPayouts(state),
    teamPaymentCollections: teamPaymentCollectionsSelectors.getTeamPaymentCollections(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  payoutsActions,
  paymentCollectionActions,
);

interface IPayoutDetailProps {
  appReady: boolean;
  actions: any;
  match: any;
  payouts: any;
  teamPaymentCollections: any;
  backendErrors: any;
  errors: any;
  isLoading: boolean;
}
@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class PayoutDetail extends React.Component<IPayoutDetailProps> {
  static defaultProps: IPayoutDetailProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    payouts: undefined,
    teamPaymentCollections: undefined,
    backendErrors: undefined,
    isLoading: false,
    errors: undefined,
  };

  componentDidMount = (): void => {
    this.props.actions.getPayout(this.props.match.params.payoutId);
  };

  statusBadges = (owingNumber, overdueNumber): React.ReactNode[] => {
    const statuses = [];

    if (owingNumber > 0) {
      statuses.push(
        <StatusBadge
          paymentText="owing"
          numberOfObjects={owingNumber}
        />,
      );
    }
    if (overdueNumber > 0) {
      statuses.push(
        <StatusBadge
          paymentText="overdue"
          numberOfObjects={overdueNumber}
        />,
      );
    }

    return statuses;
  };

  render(): React.ReactNode {
    const payout = this.props.payouts.currentPayout;
    const isLoading = this.props.payouts.isLoading && payout?.id !== this.props.match.params.payoutId;
    return (
      <div>
        <div className="row">
          <div className="col">
            <Header
              title={`Payout ${payout?.reference}`}
              isLoading={isLoading}
              badge={
                this.statusBadges(payout?.pendingPayoutLineItemsTotalCount, payout?.overduePayoutLineItemsTotalCount)
              }
              descriptors={
                [
                  {
                    icon: <Isvg src={CompetitionIcon} />,
                    descriptor: payout?.competitionName,
                  },
                ]
              }
              metadata={[
                {
                  title: 'Sent At',
                  value: payout?.createdAt !== undefined ? simpleDateTwo(payout?.createdAt) : '',
                },
                {
                  title: 'Number of Payments',
                  value: payout?.numberOfPayments?.toString(),
                },
                {
                  title: 'Amount',
                  value: formatAmount(payout?.amountInDollars),
                },
              ]}
            />
          </div>
        </div>
        <div className="main-content">
          <div className="row">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Details" isLoading={isLoading}>
                <div className="row">
                  <div className="col col-4 text-grey">
                    Reference
                  </div>
                  <div className="col">
                    {payout?.reference}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Estimated Receive Date
                  </div>
                  <div className="col">
                    2-3 business days from
                    {' '}
                    {payout?.createdAt !== undefined ? simpleDateTwo(payout?.createdAt) : ''}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Internal Identifier
                  </div>
                  <div className="col">
                    <CopyCaption text={payout?.id} />
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col">
              <PaymentCollectionsTableTeamMembers
                {...this.props.teamPaymentCollections}
                appReady={this.props.appReady}
                actions={this.props.actions}
                headerTitle="Payment Collections"
                saveFilters={false}
                hideButtons
                isLoading={this.props.teamPaymentCollections.isLoading}
                persistentFilterConfig={{
                  payoutId: this.props.match.params.payoutId,
                  id: payout.teamPaymentCollections,
                }}
                selectPaymentCollection={this.props.actions.selectPaymentCollection}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
